import {
  Fact,
  LedgerHoverCard,
  RefCode,
  StatusWord,
  formatLedgerWhen,
  formatLedgerWhenFull,
  statusToken,
} from '../../../shared/components/ledger';
import { formatCurrency } from '../../../shared/utils/currency';
import type { ActivityLedgerRowModel } from './toActivityRows';

interface ActivityHoverCardProps {
  row: ActivityLedgerRowModel;
  onOpenDetails: () => void;
}

/**
 * The row hover card: a shortcut to the booking panel, and where the facts the
 * row truncates reappear — the variation's free text, and who reviewed it.
 */
export function ActivityHoverCard({
  row,
  onOpenDetails,
}: ActivityHoverCardProps) {
  const { approval } = row;

  return (
    <LedgerHoverCard
      title={row.title}
      kind={row.isVariation ? 'Variation' : 'Labour item'}
      description={row.description ?? undefined}
      onOpenDetails={onOpenDetails}
    >
      <Fact label="Status">
        <StatusWord token={statusToken(row.status)} />
      </Fact>
      {approval && (
        <Fact label={approval.isApproved ? 'Approved by' : 'Rejected by'}>
          {`${approval.reviewedBy} · ${formatLedgerWhen(approval.reviewedAt)}`}
        </Fact>
      )}
      {approval?.rejectionReason && (
        <Fact label="Reason">{approval.rejectionReason}</Fact>
      )}
      <Fact label="Ref">
        <RefCode>{row.reference}</RefCode>
      </Fact>
      <Fact label="Site · Plot">{`${row.sitePlot.site} · ${row.sitePlot.plot}`}</Fact>
      <Fact label="Booked by">{row.bookedBy}</Fact>
      <Fact label="When">{formatLedgerWhenFull(row.bookedAt)}</Fact>
      <Fact label="Value">{formatCurrency(row.amount)}</Fact>
      {row.target != null && (
        <Fact label="Target">{formatCurrency(row.target)}</Fact>
      )}
      {row.percentBooked != null && (
        <Fact label="Booked">{row.percentBooked}%</Fact>
      )}
    </LedgerHoverCard>
  );
}
